var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"range-datepicker d-inline"},[_c('b-form-select',{staticClass:"d-inline mb-3 ml-2",attrs:{"options":_vm.dateRangeOptions},on:{"change":_vm.dateRangeChanged},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }